type JSONObject = { [key: string]: JSONValue };
type JSONValue = string | number | boolean | null | undefined | Date | JSONObject | JSONValue[];

export function snakeToCamelCase<T = JSONValue>(input: unknown): T {
  if (Array.isArray(input)) {
    return input.map(snakeToCamelCase) as unknown as T;
  }

  if (input instanceof Date) {
    return input as T;
  }

  if (isPlainObject(input)) {
    const result: JSONObject = {};
    for (const [key, value] of Object.entries(input)) {
      // _id is a special mongo field, it's idiomatic for it to remain as is
      result[key !== '_id' ? toCamel(key) : key] = snakeToCamelCase(value);
    }
    return result as T;
  }

  return input as T;
}

function isPlainObject(val: unknown): val is JSONObject {
  return typeof val === 'object' && val !== null && Object.getPrototypeOf(val) === Object.prototype;
}

function toCamel(str: string): string {
  return str.replace(/_([a-z0-9])/g, (_, char) => char.toUpperCase());
}
